// REGISTO DO TRABALHADOR (service worker)
//
// Um só sítio a registar, um só ficheiro registado: `/sw.js`. Ver o cabeçalho de
// `public/sw.js` para a história das três registas a expulsarem-se umas às
// outras e da caixa "Novidades no Estádio!" que aparecia em cada carregamento.
//
// Regra que não se quebra: daqui NUNCA sai um `confirm()` nem um `reload()`.
// O trabalhador novo entra em serviço sozinho (`skipWaiting`), e como ele vai
// sempre à rede primeiro, o carregamento normal seguinte já traz o código mais
// recente. Interromper alguém a meio de uma partida para perguntar se quer
// atualizar não serve para nada — e era exatamente o que estava a acontecer.

export const CAMINHO_TRABALHADOR = '/sw.js';
export const AMBITO_TRABALHADOR = '/';

// Em desenvolvimento não se regista nada: a cache do trabalhador serve código
// velho por cima do servidor do Vite e dá horas de depuração a um bug que não
// existe.
export function eAmbienteLocal(anfitriao) {
  return anfitriao === 'localhost' || anfitriao === '127.0.0.1' || anfitriao === '[::1]';
}

// Tranca por página: o React em StrictMode monta tudo duas vezes, e duas
// chamadas seguidas a register() com o mesmo caminho são pedidos a mais por
// nada.
let pedidoEmCurso = null;

export function esquecerRegisto() {
  pedidoEmCurso = null;
}

export function registarTrabalhador({
  navegador = globalThis.navigator,
  localizacao = globalThis.location,
  consola = globalThis.console,
} = {}) {
  if (!navegador || !('serviceWorker' in navegador)) {
    return Promise.resolve({ registado: false, motivo: 'sem-suporte' });
  }
  if (eAmbienteLocal(localizacao && localizacao.hostname)) {
    return Promise.resolve({ registado: false, motivo: 'local' });
  }
  if (pedidoEmCurso) return pedidoEmCurso;

  pedidoEmCurso = navegador.serviceWorker
    .register(CAMINHO_TRABALHADOR, { scope: AMBITO_TRABALHADOR })
    .then((registo) => ({ registado: true, registo }))
    .catch((erro) => {
      // Falhar o registo não pode derrubar a app: sem trabalhador perdem-se as
      // notificações em segundo plano, mas o estádio abre na mesma.
      consola?.warn?.('Trabalhador não registado:', erro);
      pedidoEmCurso = null;
      return { registado: false, motivo: 'erro', erro };
    });

  return pedidoEmCurso;
}
